import {SvgIcon} from './SvgIcon'

export const LawScaleIcon: SvgIcon = ({
  width = 16,
  height = 16,
  fillColor = 'currentColor',
  classes = '',
  ariaLabel,
  datacy,
  strokeWidth = 1.5,
  onClick,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 24 24"
    className={classes}
    aria-label={ariaLabel}
    data-cy={datacy}
    onClick={onClick}
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth={strokeWidth}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.5 21h13M12 21V7m0 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm2-1.8c3.073.661 2.467 2.8 5 2.8M5 8c3.359 0 2.192-2.115 5.012-2.793M7 9.556V7.75m0 1.806-1.95 4.393a.773.773 0 0 0 .37.962.785.785 0 0 0 .362.089h2.436a.785.785 0 0 0 .643-.335.776.776 0 0 0 .09-.716L7 9.556Zm10 0V7.313m0 2.243-1.95 4.393a.773.773 0 0 0 .37.962.786.786 0 0 0 .362.089h2.436a.785.785 0 0 0 .643-.335.775.775 0 0 0 .09-.716L17 9.556Z"
    />
  </svg>
)
